module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Da-Ea-Fb.16186a59.png";